var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7797 0.802943C14.9473 0.970556 15.019 1.19776 14.9948 1.41636C14.988 1.47766 14.9736 1.53828 14.9518 1.59672L10.2906 14.9144C10.189 15.2046 9.92052 15.4034 9.61326 15.416C9.306 15.4285 9.02222 15.2522 8.89733 14.9712L6.34782 9.23481L0.611416 6.6853C0.330405 6.5604 0.154107 6.27663 0.166643 5.96937C0.179178 5.66211 0.378006 5.39363 0.668257 5.29205L13.9859 0.630859C14.0444 0.608986 14.105 0.594655 14.1663 0.587862C14.2115 0.582813 14.257 0.581937 14.3019 0.585107C14.476 0.597268 14.6466 0.669881 14.7797 0.802943ZM11.3951 3.12688L2.94933 6.08289L6.74992 7.77205L11.3951 3.12688ZM7.81058 8.83271L12.4557 4.18754L9.49973 12.6333L7.81058 8.83271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.faae49541fdf32695bf45489422e22e6.svg";
export { ForwardRef as ReactComponent };